export const YESNO = [
    { value: 'Y', label: 'Si' },
    { value: 'N', label: 'No'}
]

export const TYPE_OF_ORGANIZATION = [
    { value: 'IND', label: 'Individual' },
    { value: 'SCE', label: 'Sector social economía' }
];

export const ADVICE = [
    { value: 'LEG', label: 'Legal' },
    { value: 'FIN', label: 'Financiera' },
    { value: 'ECO', label: 'Ecommerce' },
    { value: 'CEL', label: 'Crédito en línea' },
    { value: 'DDM', label: 'Desarrollo de marca' },
    { value: 'CDC', label: 'Creación de contenido' },
    { value: 'OTR', label: 'Otros' }
];

export const GENDER_OPTIONS = [
    { value: "F", label: "Femenino" },
    { value: "M", label: "Masculino" },
];

export const BUSINESS_CATEGORY = [
    { value: 'ALBE', label: 'Alimentos y Bebidas' },
    { value: 'AGGA', label: 'Agricultura y Ganadería' },
    { value: 'AREN', label: 'Arte y Entretenimiento' },
    { value: 'COMR', label: 'Comercio Minorista y Mayorista' },
    { value: 'EDUC', label: 'Educación' },
    { value: 'HODE', label: 'Hogar y Decoración' },
    { value: 'INTM', label: 'Industria Textil y Moda' },
    { value: 'INCO', label: 'Inmobiliaria y Construcción' },
    { value: 'LEGA', label: 'Legal' },
    { value: 'MAPU', label: 'Marketing y Publicidad' },
    { value: 'ARMA', label: 'Artesanías y Manualidades' },
    { value: 'SABI', label: 'Salud y Bienestar' },
    { value: 'SFIN', label: 'Servicios Financieros' },
    { value: 'TEIN', label: 'Tecnología e Informática' },
    { value: 'TUHO', label: 'Turismo y Hotelería' },
    { value: 'SPRO', label: 'Servicios Profesionales' },
    { value: 'STEC', label: 'Servicios Técnicos' },
    { value: 'CONS', label: 'Consultorías' },
    { value: 'OTRO', label: 'Otro' },
];